var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#04B7EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4829 13.3802L18.6864 12.6831L16.5422 8.33627C16.4837 8.21726 16.3873 8.12091 16.2683 8.06235C15.9698 7.915 15.6071 8.03779 15.4579 8.33627L13.3137 12.6831L8.51721 13.3802C8.38497 13.3991 8.26407 13.4615 8.1715 13.5559C8.05959 13.6709 7.99793 13.8257 8.00005 13.9862C8.00218 14.1466 8.06792 14.2997 8.18284 14.4117L11.6532 17.7951L10.8333 22.5727C10.8141 22.6839 10.8264 22.7982 10.8688 22.9027C10.9112 23.0072 10.9821 23.0977 11.0733 23.164C11.1646 23.2302 11.2726 23.2696 11.3851 23.2777C11.4976 23.2857 11.6101 23.262 11.7098 23.2094L16 20.9537L20.2902 23.2094C20.4074 23.2717 20.5434 23.2925 20.6737 23.2698C21.0024 23.2131 21.2235 22.9014 21.1668 22.5727L20.3469 17.7951L23.8172 14.4117C23.9117 14.3191 23.974 14.1982 23.9929 14.066C24.0439 13.7354 23.8135 13.4294 23.4829 13.3802Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.543bc9a3d464e8c54fd357c89f6e8446.svg";
export { ForwardRef as ReactComponent };